import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import axios from 'axios';
import { API_URL } from './config';
import {
  Assignment, Group, BarChart, EventRepeat,
  Map, Insights, CalendarToday, CheckCircle,
  LocationCity, LocationOn, Grading, ReportProblem, CloudUpload, Person, Summarize, Biotech,
  ManageAccounts, EventBusy, CalendarMonth, PestControl, Science, Assessment, Campaign,
  FolderCopyOutlined,
} from '@mui/icons-material';
import { Route } from '@mui/icons-material';
import { useAuth } from './AuthContext';
import PainelHome from './PainelHome';
import TovisHeader from './TovisHeader';

interface DashboardProps { onNavegar: (pagina: string) => void; }

const MODULES = [
  { titulo: 'Fluxo', descricao: 'Seu piloto do dia: o que fazer agora e em que ordem', muiIcon: Route, pagina: 'fluxo', url: '/fluxo/', icon: '🧭', cat: 'Supervisão', accent: '#2457E6' },
  { titulo: 'Minha Rotina', descricao: 'Guia passo a passo diário', muiIcon: CheckCircle, pagina: 'rotina', icon: '🧠', cat: 'Supervisão', accent: '#00b8cc' },

  { titulo: 'Alertas', descricao: 'Lembretes e prazos importantes', pagina: 'alertas', icon: '🔔', cat: 'Supervisão', accent: '#e0242b' },
  { titulo: 'FAD-01',                     descricao: 'Lançar produção diária do agente',   muiIcon: Assignment,    pagina: 'fad01',                icon: '📋', cat: 'Produção',    accent: '#0066CC' },
  { titulo: 'FAD-01 em Grade', descricao: 'Lançar a produção do dia inteiro de uma vez', muiIcon: Grading, pagina: 'fad01_grade', url: '/fad01-grade.html', icon: '🗒️', cat: 'Produção', accent: '#0066CC' },
  { titulo: 'Resumo Semanal',             descricao: 'Relatório consolidado por dia',       muiIcon: BarChart,      pagina: 'resumo_semanal',       icon: '📊', cat: 'Relatórios',  accent: '#34C759' },
  { titulo: 'Resumo Geral',               descricao: 'Consolidado por SE e ciclo',         muiIcon: Insights,      pagina: 'resumo_geral',         icon: '📈', cat: 'Relatórios',  accent: '#5856D6' },
  { titulo: 'Quadro de Positividade', descricao: 'Positivos por tipo de depósito, por área', muiIcon: Biotech, pagina: 'quadro_positividade', icon: '🧫', cat: 'Relatórios', accent: '#7F77DD' },
  { titulo: 'Quadro de Positividade LIRAa', descricao: 'Positividade, auditoria e consolidado para o LIRAa Digital', muiIcon: Assessment, pagina: 'liraa_quadro', icon: '📊', cat: 'Relatórios', accent: '#1D4ED8' },
  { titulo: 'Calendário Epidemiológico', descricao: 'Calendário SE 2026 da Bahia',         muiIcon: CalendarToday, pagina: 'calendario_epi',       icon: '📅', cat: 'Relatórios',  accent: '#00b8cc' },
  { titulo: 'Pendências',                 descricao: 'Imóveis fechados e recusados',       muiIcon: ReportProblem, pagina: 'pendencias',           icon: '⚠️', cat: 'Operacional', accent: '#FF9500' },
  { titulo: 'Boletim de Ponto',           descricao: 'Frequência e produção dos agentes',  muiIcon: CheckCircle,   pagina: 'boletim_ponto',        icon: '✅', cat: 'RH',         accent: '#FF2D55' },
  { titulo: 'RGs - Área', descricao: 'Reconhecimento geográfico — quarteirões, ruas e imóveis', muiIcon: Map, pagina: 'cadastro_area', icon: '🗺️', cat: 'Territorial', accent: '#065F46' },
  { titulo: 'Upload',                     descricao: 'Importar dados da planilha',         muiIcon: CloudUpload,   pagina: 'upload',               icon: '☁️', cat: 'Sistema',     accent: '#5856D6' },
  { titulo: 'FAD-07',                     descricao: 'Resumo semanal por área',             muiIcon: CalendarToday, pagina: 'fad07',                icon: '📅', cat: 'Produção',    accent: '#FF9500' },
  { titulo: 'FAD-07 Geral',              descricao: 'Consolidado geral por área e ciclo',  muiIcon: CalendarToday, pagina: 'fad07geral',           icon: '📆', cat: 'Relatórios',  accent: '#E65C00' },
  { titulo: 'Quadro do Supervisor',       descricao: 'Síntese do período para supervisão', muiIcon: Grading,       pagina: 'quadro_supervisor',    icon: '📋', cat: 'Supervisão',  accent: '#7C3AED' },
  { titulo: 'Agentes',                    descricao: 'Gerenciar equipe de ACEs',           muiIcon: Group,         pagina: 'agentes',              icon: '👥', cat: 'Equipe',      accent: '#AF52DE' },
  { titulo: 'Cobertura de Área',          descricao: 'Mapa de quarteirões por status',     muiIcon: Map,           pagina: 'cobertura',            icon: '🌐', cat: 'Territorial', accent: '#30B0C7' },
  { titulo: 'Áreas de Trabalho',          descricao: 'Cadastro e gestão de áreas',         muiIcon: LocationCity,  pagina: 'areas',                icon: '📍', cat: 'Territorial', accent: '#0F5132' },
  { titulo: 'Quarteirões',                descricao: 'Gestão de quarteirões por área',     muiIcon: LocationOn,    pagina: 'quarteiraos',          icon: '🏛️', cat: 'Territorial', accent: '#92400E' },
  { titulo: 'Ciclos',                     descricao: 'Gerenciar ciclos epidemiológicos',   muiIcon: EventRepeat,   pagina: 'configuracoes',        icon: '🔄', cat: 'Gestão',      accent: '#0F766E' },
  { titulo: 'Painel Agente',              descricao: 'Indicadores por agente e área',      muiIcon: Person,        pagina: 'painel_agente',        icon: '💼', cat: 'Supervisão', accent: '#1B3A6B' },
  { titulo: 'PE — Ponto Estratégico',     descricao: 'Cadastro e gestão de PEs',           muiIcon: LocationOn,    pagina: 'ponto_estrategico_pe', icon: '📌', cat: 'Territorial', accent: '#0277BD' },
  { titulo: 'FAD-07 — Ponto Estratégico', descricao: 'Consolidado semanal de PEs',         muiIcon: Summarize,     pagina: 'fad07_pe',             icon: '📄', cat: 'Produção',    accent: '#00838F' },
  { titulo: 'Laboratório',               descricao: 'Amostras e resultados laboratoriais', muiIcon: Biotech,       pagina: 'laboratorio',          icon: '🔬', cat: 'Operacional', accent: '#8b5cf6' },
  { titulo: 'TUBITOS',                   descricao: 'Próximo nº da etiqueta de cada agente', muiIcon: Biotech,     pagina: 'tubitos',              icon: '🧪', cat: 'Operacional', accent: '#0F766E' },
  { titulo: 'LIRAa — Ciclo e Equipe', descricao: 'Ciclo, áreas sorteadas, equipe e imóveis inspecionados', muiIcon: PestControl, pagina: 'liraa_ciclo', icon: '🦟', cat: 'Operacional', accent: '#0E7490' },
  { titulo: 'Laboratório LIRAa', descricao: 'Tubitos do LIRAa: pendentes e resultados', muiIcon: Science, pagina: 'liraa_laboratorio', icon: '🧪', cat: 'Operacional', accent: '#6D28D9' },
  { titulo: 'Usuários',                  descricao: 'Gerenciar usuários e permissões',      muiIcon: ManageAccounts, pagina: 'usuarios',            icon: '🔐', cat: 'Administração', accent: '#1976D2' },
  { titulo: 'Férias e Licenças',         descricao: 'Afastamentos, faltas e saídas de turno', muiIcon: EventBusy,      pagina: 'afastamentos',        icon: '📅', cat: 'RH',            accent: '#FF6B35' },
  { titulo: 'Planner Férias', descricao: 'Quadro do ano: quem está fora, quando volta e quantos ficam em campo', muiIcon: CalendarMonth, pagina: 'planner_ferias', icon: '🗓️', cat: 'RH', accent: '#0D3B66' },
  { titulo: 'Relatório Mensal',         descricao: 'Relatório 2.0 — consolidado do mês civil', muiIcon: Summarize,    pagina: 'relatorio_mensal',    icon: '📑', cat: 'Relatórios',    accent: '#1B6B3A' },
  { titulo: 'Comunicação', descricao: 'Números do mês para o Instagram da Secretaria (entrega dia 30)', muiIcon: Campaign, pagina: 'comunicacao', icon: '📣', cat: 'Relatórios', accent: '#0D3B66' },
  { titulo: 'Arquivos', descricao: 'Cópias congeladas dos relatórios: FAD-07, fechamentos, ponto, LIRAa e mais', muiIcon: FolderCopyOutlined, pagina: 'arquivos', icon: '🗂️', cat: 'Relatórios', accent: '#0E5A4A' },
  { titulo: 'Fechamento de Área', descricao: 'Conciliar RG × campo e fechar a área no ciclo', muiIcon: Lock, pagina: 'fechamento_area', icon: '🔒', cat: 'Territorial', accent: '#1B3A6B' },
  { titulo: 'Fechamento de Ciclo', descricao: 'Quadro Demonstrativo por área e Condensado para Amargosa', muiIcon: Summarize, pagina: 'fechamento_ciclo', icon: '🗂️', cat: 'Territorial', accent: '#1B3A6B' },
  { titulo: 'Histórico Quarteirão',     descricao: 'Cobertura territorial — quarteirões trabalhados vs faltantes', muiIcon: Map, pagina: 'historico_quarteirao', icon: '🗺️', cat: 'Territorial', accent: '#4f9e6f' },
];

export default function Dashboard({ onNavegar }: DashboardProps) {
  const { usuario, logout, token } = useAuth();
  const [cicloAtivo, setCicloAtivo] = useState<string | null>(null);
  const [alertasTotal, setAlertasTotal] = useState<number>(0);
  const [alertasUrgentes, setAlertasUrgentes] = useState<number>(0);
  useEffect(() => {
    if (!token) return;
    axios.get(`${API_URL}/api/alertas/contador`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => { setAlertasTotal(r.data.total ?? 0); setAlertasUrgentes(r.data.urgentes ?? 0); })
      .catch(() => {});
  }, [token]);
  const [fad01Hoje, setFad01Hoje] = useState<number>(0);

  useEffect(() => {
    if (!token) return;
    axios.get(`${API_URL}/api/ciclos/`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => { const c = r.data.find((x: any) => x.ativo); if (c) setCicloAtivo(c.nome); })
      .catch(() => {});
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    axios.get(`${API_URL}/api/painel-home/dados`)
      .then(r => setFad01Hoje(r.data.lancamentos_hoje || 0))
      .catch(() => setFad01Hoje(0));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={{
      minHeight: '100vh', bgcolor: '#050d1a',
      display: 'flex', flexDirection: 'column',
      fontFamily: "'Inter', sans-serif",
    }}>
      <TovisHeader
        alertasTotal={alertasTotal}
        alertasUrgentes={alertasUrgentes}
        onAlertas={() => onNavegar('alertas')}
        nomeUsuario={usuario?.nome ?? 'Supervisor'}
        papelUsuario={usuario?.perfil ?? 'admin'}
        ciclo={cicloAtivo ?? undefined}
        fad01Hoje={fad01Hoje}
        onSair={logout}
      />

      <Box sx={{ px: { xs: 2, md: 4 }, pt: 4, pb: 6, maxWidth: 1100, mx: 'auto', width: '100%', flexGrow: 1 }}>
        <PainelHome onNavegar={onNavegar} />

        {/* Cabeçalho da seção */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#f0f4f8', lineHeight: 1, fontFamily: "'Inter', sans-serif" }}>
              Módulos
            </div>
            <div style={{ fontSize: 11, color: '#8a95a3', marginTop: 5, fontFamily: "'Inter', sans-serif" }}>
              Selecione um módulo para acessar
            </div>
          </div>
        </div>

        {/* Grid de cards */}
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2,1fr)', sm: 'repeat(3,1fr)', md: 'repeat(4,1fr)', lg: 'repeat(5,1fr)' },
          gap: '12px',
        }}>
          {MODULES.map((mod) => (
            <Box
              key={mod.pagina}
              onClick={() => (mod as any).url ? (window.location.href = (mod as any).url) : onNavegar(mod.pagina)}
              sx={{
                position: 'relative',
                borderRadius: '14px',
                overflow: 'hidden',
                background: 'linear-gradient(145deg, #0d1e38 0%, #081629 100%)',
                border: '1px solid rgba(255,255,255,0.07)',
                boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                padding: '20px 18px 18px',
                cursor: 'pointer',
                display: 'flex', flexDirection: 'column',
                transition: 'all 0.22s cubic-bezier(.34,1.56,.64,1)',
                '&:hover': {
                  transform: 'translateY(-4px) scale(1.02)',
                  border: `1px solid ${mod.accent}55`,
                  boxShadow: `0 12px 32px rgba(0,0,0,0.5), 0 0 0 1px ${mod.accent}44, inset 0 1px 0 ${mod.accent}20`,
                },
              }}
            >
              {/* Orb de fundo */}
              <div style={{
                position: 'absolute', right: -20, top: -20,
                width: 90, height: 90, borderRadius: '50%',
                background: `radial-gradient(circle, ${mod.accent}20 0%, transparent 70%)`,
                opacity: 0.4, pointerEvents: 'none',
              }} />

              {/* Ícone emoji */}
              <div style={{ fontSize: 30, marginBottom: 12, lineHeight: 1 }}>
                {mod.icon}
              </div>

              {/* Título */}
              <div style={{
                fontSize: 13, fontWeight: 700, color: '#c4cdd8',
                marginBottom: 5, fontFamily: "'Inter', sans-serif",
              }}>
                {mod.titulo}
              </div>

              {/* Descrição */}
              <div style={{
                fontSize: 11, color: '#8a95a3', lineHeight: 1.45,
                marginBottom: 14, fontFamily: "'Inter', sans-serif",
                flex: 1,
              }}>
                {mod.descricao}
              </div>

              {/* Rodapé */}
              <div style={{
                borderTop: '1px solid rgba(255,255,255,0.06)',
                paddingTop: 10,
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              }}>
                <span style={{
                  fontSize: 9, fontWeight: 700, letterSpacing: '0.08em',
                  textTransform: 'uppercase', color: mod.accent,
                  fontFamily: "'Inter', sans-serif",
                }}>
                  {mod.cat}
                </span>
                <div style={{
                  width: 24, height: 24, borderRadius: '50%',
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.07)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                       stroke="#8a95a3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 5h6M5.5 2.5L8 5l-2.5 2.5" />
                  </svg>
                </div>
              </div>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Rodapé da página */}
      <Box sx={{ py: 2, textAlign: 'center', borderTop: '1px solid rgba(255,255,255,0.05)', bgcolor: '#050d1a' }}>
        <Typography sx={{ fontSize: '0.72rem', color: '#2a3a4c' }}>
          &copy; 2026 Tovis &mdash; Desenvolvido por <strong style={{ color: '#4a5a6c' }}>Walber Reis</strong>
        </Typography>
      </Box>
    </Box>
  );
}
